import React from 'react';

export const TgLogo: React.FC = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4411_262334)">
      <path
        d="M12 24.0039C18.6274 24.0039 24 18.6313 24 12.0039C24 5.37649 18.6274 0.00390625 12 0.00390625C5.37258 0.00390625 0 5.37649 0 12.0039C0 18.6313 5.37258 24.0039 12 24.0039Z"
        fill="#4EA4F6"
      />
      <path
        d="M4.99431 11.8998C4.99431 11.8998 10.9943 9.43738 13.0752 8.57033C13.8729 8.22351 16.5781 7.11368 16.5781 7.11368C16.5781 7.11368 17.8267 6.62813 17.7226 7.80732C17.6879 8.29287 17.4105 9.99229 17.133 11.8304C16.7169 14.4316 16.266 17.2755 16.266 17.2755C16.266 17.2755 16.1966 18.0732 15.607 18.2119C15.0174 18.3507 14.0463 17.7264 13.8729 17.5877C13.7342 17.4836 11.2718 15.9229 10.37 15.1599C10.1273 14.9518 9.8498 14.5356 10.4047 14.0501C11.6533 12.9056 13.1446 11.4836 14.0463 10.5819C14.4625 10.1657 14.8787 9.1946 13.1446 10.3738C10.6822 12.0732 8.25442 13.6686 8.25442 13.6686C8.25442 13.6686 7.69951 14.0154 6.65905 13.7033C5.61858 13.3911 4.40471 12.975 4.40471 12.975C4.40471 12.975 3.57234 12.4547 4.99431 11.8998Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4411_262334">
        <rect width="24" height="24" fill="white" transform="translate(0 0.00390625)" />
      </clipPath>
    </defs>
  </svg>
);
